export const APPROVAL_WORKFLOW = {
  getApprovalWorkflows: [
    {
      WorkflowOperation: 'moneyOut',
      NumberOfValidators: 2
    },

    {
      WorkflowOperation: 'moneyIn',
      NumberOfValidators: 3
    }
  ]
};
